import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export function PublicFooter() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="public-footer" className="border-t border-[#083A6B]/15 bg-[#F5F1E8] mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            {BRAND.logoUrl ? (
              <img src={BRAND.logoUrl} alt={BRAND.name} className="h-10 w-auto" width="180" height="70" />
            ) : (
              <span className="font-public-title text-xl text-[#083A6B] font-bold">{BRAND.name}</span>
            )}
          </div>
          <p className="text-sm text-stone-600 leading-relaxed max-w-sm">
            {BRAND.tagline}. Reserve com segurança e tenha a tranquilidade de falar
            diretamente com quem opera cada pousada.
          </p>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-stone-500 font-semibold mb-4">
            Navegação
          </div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="text-stone-700 hover:text-[#083A6B]">Início</Link></li>
            <li><Link to="/pousadas" className="text-stone-700 hover:text-[#083A6B]">Pousadas</Link></li>
            <li><Link to="/contato" className="text-stone-700 hover:text-[#083A6B]">Contato</Link></li>
            <li><Link to="/login" className="text-stone-500 hover:text-[#083A6B]">Área administrativa</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-stone-500 font-semibold mb-4">
            Contato
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={`https://wa.me/${BRAND.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 text-stone-700 hover:text-[#083A6B]"
              >
                <MessageCircle size={14} /> WhatsApp
              </a>
            </li>
            <li>
              <a href={`tel:+${BRAND.whatsapp}`} className="inline-flex items-center gap-2 text-stone-700 hover:text-[#083A6B]">
                <Phone size={14} /> +55 11 91417-5095
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`} className="inline-flex items-center gap-2 text-stone-700 hover:text-[#083A6B]">
                <Mail size={14} /> {BRAND.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#083A6B]/15">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5 text-xs text-[#6B7280] flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {year} {BRAND.name}. Todos os direitos reservados.</span>
          <span className="text-[#6B7280]/70">Pousadas selecionadas · Reservas assistidas</span>
        </div>
      </div>
    </footer>
  );
}
